import { UserResource } from './user.resource';
import { user as userStore } from '../../store';
import { setUser } from '../../lib/sentry';
class UserService {
    constructor() {
        this.userResource = new UserResource();
    }
    async resolve() {
        const profile = await this.userResource.getProfile();
        setUser({
            id: String(profile.id),
            email: profile.email,
            username: profile.username,
        });
        userStore.setProfile(profile);
    }
    getUser() {
        return userStore.getUserSync();
    }
    getUserById(userId) {
        return this.userResource.getUserById(userId);
    }
    getUsers(project) {
        return this.userResource.getUsers(project);
    }
    getUserList(params) {
        return this.userResource.getUserList(params);
    }
    updateUserAccount(userId, membershipExpiryDate, accountType) {
        return this.userResource.updateUserAccount(userId, membershipExpiryDate, accountType);
    }
}
export default new UserService();
